export function checkStrEmpty(str) {
    return !(str && str.length > 1 && str.split(' ').join('').length > 0)
}